import { useState } from 'react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import hasFeature from 'modules/core/lib/hasFeature'
import { apiClient as ApiClient } from 'modules/core/lib/mobx-rest'

interface Result {
  loading: boolean
  error: string | undefined
}

const url = `/performance_reviews/setup`

export const useReviewsFeatureSetup = (): Result => {
  const [error, setError] = useState<string>()

  const { loading } = useAsyncData(async () => {
    const isPackagingPaywall = hasFeature('dev_packaging_paywalls')

    if (isPackagingPaywall) {
      try {
        await ApiClient().post(url)
      } catch (error) {
        setError('Error in performance review setup')
      }
    }
  }, [])

  return {
    loading,
    error,
  }
}
